import { Field } from 'formik';
import styled from 'styled-components/macro';

export const TextArea = styled(Field)<{ margin?: string; rows?: number; $autoResize?: boolean }>`
  width: 100%;
  height: auto;
  max-height: 20rem;
  padding: ${({ theme }) => theme.spacing.one} ${({ theme }) => theme.spacing.zero_3};
  border: 1px solid;
  border-color: ${props =>
    props.error === 'hasError' ? props.theme.colors.negative_dark : props.theme.colors.black_20};
  border-radius: ${({ theme }) => theme.spacing.zero_1};

  background-color: ${({ theme }) => theme.colors.white};
  outline: none;

  ${({ margin }) => margin && ` margin: ${margin}; `}

  ${({ $autoResize, rows, theme }) =>
    $autoResize &&
    `
    field-sizing: content;
    min-height: calc(${rows}lh + 2 * ${theme.spacing.one} + 2px);
  `}


  resize: vertical;
  :focus {
    border: 1px solid;
    border-color: ${props =>
      props.error === 'hasError' ? props.theme.colors.negative_dark : props.theme.colors.black};
  }
  :disabled {
    background-color: ${({ theme }) => theme.colors.black_10};
    color: ${({ theme }) => theme.colors.black_40};
    cursor: not-allowed;
  }
  ::placeholder {
    color: ${({ theme }) => theme.colors.black_40};
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    font-size: ${({ theme }) => theme.fontSize.md};
    line-height: ${({ theme }) => theme.lineHeight.one_1};
    letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  }
`;
